<template>

<div class="wrapper meeting">
  <!-- <div id="tabchange" @click="checking()"></div> -->
    <div class="ag-header">
      <div class="ag-header-lead">
        <img class="header-logo" :src="require('../../../assets/img/logo.png')" alt="" />
        <span id="tabclose" @click="changetab()"></span>
      </div>
      <div class="ag-header-msg meeting-label res-hide">
          <span class="text-muted">Meeting ID</span>&nbsp;<span id="room-name">{{channel}}</span>
      </div>
      <div class="ag-header-msg res-hide">
          <span class="text-muted">Title</span>&nbsp;<span id="room-name">{{job_title}}</span>
      </div>
      <div class="ag-header-msg res-hide">
          <span class="text-muted">Organized by</span>&nbsp;<span id="room-name">{{organization}}</span>
      </div>
      <div class="ag-header-msg time-duration">
          <span id="room-name">{{duration}}</span>
      </div>
      <div class="ag-header-msg end-interview" style="" @click="exitconfirmation">
          <span id="room-name" v-if="type == 2">End Interview</span>
          <span id="room-name" v-if="type != 2">Leave Interview</span>
      </div>
    </div>
    <div class="ag-main">
      <div class="ag-container video-res">
        <div class="row">
          <div class="col-md-12 p-1 canvas-res">
            <div id="ag-canvas">
            </div>
            <div class="white-board-text" v-if="showwhiteboard">
              <strong class="pull-left">whiteboard</strong>
              <span class="pull-right clear-board" @click="clearwhiteboard()">Clear <i class="fa fa-trash-o" aria-hidden="true"></i></span><br>
              <hr style="margin: 8px;border-top: 1px solid #5555554a;">
              <textarea @change="sendwhiteboard()" v-model="boardtext" style="border: 0px solid #ccc;" class="form-control" placeholder="type here..." cols="25" rows="12"></textarea>
              </div>
            <div @click="showwhiteboard = !showwhiteboard" class="white-board" v-if="type1 == 2">
              <span v-if="!showwhiteboard">whiteboard <i class="fa fa-file-text" aria-hidden="true"></i></span>
              <span v-if="showwhiteboard">Close <i class="fa fa-times" aria-hidden="true"></i></span>
            </div>
            <div @click="viewCodeEditor()" class="white-board" v-if="type == 3 || type == '3'">
              <span>Code Editor <i class="fa fa-file-text" aria-hidden="true"></i></span>
            </div>
            <div @click="viewCodeEditor()" class="white-board" v-if="type == 2 || type == '2'">
              <span>View Code <i class="fa fa-file-text" aria-hidden="true"></i></span>
            </div>
          </div>
          <div class="col-md-12 p-1 footerfix">
            <div class="ag-btn-group video-fot-res">
              <!-- <span
                @click="handleExit"
                class="ag-btn exitBtn"
                :class="{'disabled': !readyState}"
                title="Exit">
                <i class="ag-icon ag-icon-leave"></i>
              </span> -->
              <span v-if="attendeeMode !== 'audience'"
                @click="handleMic"
                class="ag-btn audioControlBtn"
                title="Enable/Disable Audio">
                <i class="ag-icon ag-icon-mic"></i>
                <i class="ag-icon ag-icon-mic-off"></i>
              </span>
              <span v-if="attendeeMode === 'video'"
                @click="handleCamera"
                class="ag-btn videoControlBtn"
                title="Enable/Disable Video">
                <i class="ag-icon ag-icon-camera"></i>
                <i class="ag-icon ag-icon-camera-off"></i>
              </span>
              <span
                @click="switchDisplay"
                class="ag-btn displayModeBtn"
                :class="{'disabled': streamList.length > 4}"
                title="Switch Display Mode">
                <i class="ag-icon ag-icon-switch-display"></i>
              </span>
              <span
                class= "ag-btn disableRemoteBtn"
                :class="{'disabled': streamList.length > 4 || displayMode !== 'pip'}"
                @click="sharescreen"
                title="Hide Remote Stream">
                <i class="ag-icon ag-icon-remove-pip"></i>
              </span>
              <span style="font-size: 44px;"
                class= "ag-btn disableRemoteBtn"
                @click="sendReminderNotification"
                title="Send reminder notification">
                <i class="fa fa-envelope fa-3" aria-hidden="true"></i>
              </span>
              <span style="font-size: 44px;" class="ag-btn" @click="openNav">
                <i class="fa fa-send-o" aria-hidden="true"></i>
                <span v-if="chatMessages.length != 0 && badgeShow" class="badge badge-light">&nbsp;</span>
                <!-- chatMessages  -->
              </span>
            </div>
            <!-- <p id="note-text"></p>
            <a @click="voicetotext()">voicetotext</a>
            <a @click="voiceEnd()">voice end</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal overlay fade in" id="modal-default" style="display: block;" v-show="showexitform">
        <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
          <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
            <div class="modal-body" style="padding:0px">
              <div class="row" >
                <div class="col-md-12 " style="padding:0px">
                  <div class="col-md-12" style="text-align: center;">
                    <h5 style="padding: 9px;" v-if="type == 2">Do you want to end the Interview?</h5>
                    <h5 style="padding: 9px;" v-if="type != 2">Do you want to leave the Interview?</h5>
                      <div class="form-submit" style="text-align: center;">
                        <div @click="handleExit" :class="{'disabled': !readyState}" class="ag-header-msg end-interview" style="width: 27%;margin-left: auto;margin-right: auto;">
                            <!-- <span id="room-name">End Interview</span> -->
                            <span id="room-name" v-if="type == 2">End Interview</span>
                            <span id="room-name" v-if="type != 2">Leave Interview</span>
                        </div>
                      </div>
                    <h6 @click="closeendinterview()" style="color: #5bad2b;padding: 18px !important;cursor:pointer;">Continue with meeting </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
      </div>
      <div class="modal overlay fade in" id="myModal1">
        <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
          <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
            <div class="modal-body" style="padding:0px">
              <div class="row" >
                <div class="col-md-12 " style="padding:17px">
                  <div class="col-md-12" style="text-align: center;">
                    <p style="font-size: 20px;font-weight: 600;">Window Violated</p><br>
                    <button class="btn btn-success" @click="closeViolated()">Ok</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
      </div>
      <div id="myModal2" class="sidenav">
        <div class="top-div">
          <div class="chat-header" >
            <h5 class="header">Chat</h5>
            <a href="javascript:void(0)" class="closebtn" v-on:click="closeNav()">&times;</a>
          </div>
          <div class="chat-message">
            <div class="messages-content" id="messages-content">
              <div v-for="(x, index) in chatMessages" :key="index">
                <div class="speech-wrapper">
                  <div class="chatbox triangle right-top alt" v-if="x.self==true && x.text != '-screen-'">
                    <div class="txt">
                      <p class="chat-header-name">{{x.name}}</p>
                      {{x.text}}
                      <!-- <span class="timestamp">10:20 pm</span> -->
                    </div>
                  </div>
                  <div class="chatbox_other triangle left-top altleft" v-if="x.self==false && x.text != '-screen-'">
                    <div class="txt">
                      <p class="chat-header-name">{{x.name}}</p>
                      {{x.text}}
                      <!-- <span class="timestamp">10:20 pm</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-chat">
          <div class="footer-chat-input">
            <b-form-input v-model="chatMsg" type="text" placeholder="Enter message" @keyup.enter="sendChatMessage(chatMsg)" />
          </div>
          <button class="button-send pull-right" v-on:click="sendChatMessage(chatMsg)">
            <i class="fa fa-send-o" style='color: white' aria-hidden="true"></i>
          </button>
        </div>
      </div>
  </div>
</template>

<script>
import { merge } from 'lodash'
import '../assets/fonts/css/icons.css'
import * as Cookies from 'js-cookie'
import axios from 'axios'
import { AGORA_APP_ID } from '../agora.config.js'
import { BaseURL } from '../../../shared/classes'
import AgoraRTC from 'agora-rtc-sdk'
// import AgoraRTM from 'agora-rtm-sdk'
import AgoraRTM from 'agora-rtm-react'
import moment from 'moment'
import momentsone from 'moment-timezone'
import router from '../../../router/index'
import $ from 'jquery'
const username = '78afdf18ee1e45d99d8afe1768be11d4'
const password = '443f86d2419f45feb36d375f0b3439fd'
const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
const tileCanvas = {
  1: ['span 12/span 24'],
  2: ['span 12/span 12/13/25', 'span 12/span 12/13/13'],
  3: ['span 6/span 12', 'span 6/span 12', 'span 6/span 12/7/19'],
  4: [
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12/7/13'
  ],
  5: [
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 9/span 16/10/21'
  ],
  6: [
    'span 3/span 4/13/7',
    'span 3/span 4/13/11',
    'span 3/span 4/13/15',
    'span 3/span 4/13/19',
    'span 3/span 4/13/23',
    'span 9/span 16/10/21'
  ],
  7: [
    'span 3/span 4/13/5',
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 3/span 4/13/25',
    'span 9/span 16/10/21'
  ]
}
const SpeechRecognition = window.speechRecognition || window.webkitSpeechRecognition
const recognition = new SpeechRecognition()
export default {
  data () {
    return {
      client: {},
      localStream: {},
      shareClient: {},
      shareStream: {},
      userstype: '',
      displayMode: 'pip',
      streamList: [],
      chooseval: [],
      data: [],
      readyState: false,
      channel: Cookies.get('channel'),
      type3: localStorage.getItem('stType'),
      type1: localStorage.getItem('type'),
      job_title: localStorage.getItem('job_title'),
      type: Cookies.get('type'),
      organization: localStorage.getItem('organization'),
      sid: Cookies.get('sid'),
      showexitform: false,
      showwhiteboard: false,
      showeditor: false,
      boardtext: '',
      appId: AGORA_APP_ID,
      screenStream: {},
      screenClient: {},
      resourceId: '',
      agora_sid: '',
      screenshare: 0,
      s: 0,
      duration: '',
      durationval: '',
      start_datetime: '',
      temptoken: '',
      current_date: '',
      timezone: momentsone.tz.guess(),
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      noteContent: '',
      checkStartRecording: false,
      rtmClient: null,
      rtmChannelName: null,
      clientRTM: {},
      currentUser: '',
      channel1: {},
      channelList: [],
      streamCount: 0,
      channelMessage: null,
      channelMessageList: [],
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      chatModalShow: false,
      chatMsg: '',
      chatMessages: [],
      badgeShow: false
    }
  },

  props: [
    'transcode',
    'attendeeMode',
    'videoProfile',
    'baseMode',
    'uid'
  ],

  methods: {
    voicetotext () {
      recognition.continuous = true
      if (this.noteContent.length) {
        this.noteContent += ' '
      }
      recognition.start()
      console.log(this.noteContent)
    },
    voiceEnd () {
      recognition.stop()
      recognition.onresult = function (event) {
        console.log(event)
        var current = event.resultIndex
        var transcript = event.results[current][0].transcript
        this.noteContent = this.noteContent + transcript + '<br>'
        $('#note-text').append('<b><i>You said: </i></b> ' + this.noteContent)
        this.noteContent = ''
      }
    },
    sendReminderNotification () {
      const mainurl = '/dashboard/send_connect_remainder_mail/' + this.sid
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        console.log(response.data)
      }).catch(e => {
        console.log(e)
      })
    },
    gettimer (s) {
      this.s += s
      s = this.s
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      // console.log(this.addZ(hrs) + ':' + this.addZ(mins) + ':' + this.addZ(secs))
      this.duration = this.addZ(hrs) + ':' + this.addZ(mins) + ':' + this.addZ(secs)
      if (this.addZ(hrs) > 0) {
        this.durationval = this.addZ(hrs) + 'h ' + this.addZ(mins) + 'm  ' + this.addZ(secs) + 's '
      } else {
        this.durationval = this.addZ(mins) + 'm ' + this.addZ(secs) + 's '
      }
    },
    addZ (n) {
      return (n < 10 ? '0' : '') + n
    },
    async streamInit (uid1, attendeeMode, videoProfile, config) {
      console.log($.streamList)
      const type = localStorage.getItem('type')
      let types = ''
      console.log(type)
      if (type === 1 || type === '1') {
        types = 'org'
      } else if (type === 2 || type === '2') {
        types = 'int'
      } else {
        types = 'candidate'
      }
      const defaultConfig = {
        streamID: uid1,
        audio: true,
        video: true,
        screen: false,
        usertype: types,
        types: 'video',
        inttype: Cookies.get('type')
      }

      switch (attendeeMode) {
        case 'audio-only':
          defaultConfig.video = false
          break
        case 'audience':
          defaultConfig.video = false
          defaultConfig.audio = false
          break
        default:
        case 'video':
          break
      }
      const stream = AgoraRTC.createStream(merge(defaultConfig, config))
      stream.setVideoProfile(videoProfile)
      var uid = this.type + '-' + types + '-' + uid1
      var token = null
      // Initialize AgoraRTM client
      this.clientRTM = await AgoraRTM.createInstance(this.appId)
      await this.clientRTM.login({ uid, token })
      this.currentUser = this.clientRTM.context._uid
      this.channel1 = await this.clientRTM.createChannel(this.channel)
      await this.channel1.join()
      await this.channel1.sendMessage({ text: uid, type: 'text' })
      return stream
    },
    clearwhiteboard () {
      this.boardtext = ''
    },
    sendwhiteboard () {
      const mainurl = '/dashboard/add_schedule_notes'
      const postdatas = {
        schedule_id: this.sid,
        interview_notes: this.boardtext
      }
      axios.post(`${BaseURL}${mainurl}`, { formData: postdatas }, this.config).then(response => {
        console.log(response.data)
      }).catch(e => {
        console.log(e)
      })
    },
    subscribeStreamEvents () {
      const rt = this
      rt.client.on('stream-added', function (evt) {
        const stream = evt.stream
        console.log('check stream-added: ', stream)
        console.log('New stream added: ' + stream.getId())
        console.log('At ' + new Date().toLocaleTimeString())
        console.log('Subscribe ', stream)
        rt.client.subscribe(stream, function (err) {
          console.log('Subscribe stream failed', err)
        })
      })

      rt.client.on('peer-leave', function (evt) {
        console.log('Peer has left: ' + evt.uid)
        console.log(new Date().toLocaleTimeString())
        console.log(evt)
        rt.removeStream(evt.uid)
        for (var i = 0; i < rt.channelMessageList.length; i++) {
          var string = rt.channelMessageList[i]
          var substring = evt.uid
          if (string.includes(substring)) {
            rt.channelMessageList.splice(i, 1)
          }
        }
      })

      rt.client.on('stream-subscribed', async function (evt) {
        const stream = evt.stream
        console.log('check stream-subscribed: ', stream)
        console.log('Got stream-subscribed event')
        console.log(new Date().toLocaleTimeString())
        console.log('Subscribe remote stream successfully: ' + stream.getId())
        console.log(evt)
        rt.addStream(stream)
        // await rt.sleep(1000)
        // if (rt.screenshare === 1 && stream.screen === false) {
        for (var i = 0; i < rt.channelMessageList.length; i++) {
          var string = rt.channelMessageList[i]
          var substring = stream.params.streamID
          var inarr = 0
          if (string.includes(substring)) {
            inarr = 1
            break
          } else {
            inarr = 0
          }
        }
        if (rt.screenshare === 1 && inarr === 0) {
        // if (stream.screen === false) {
          var uid2 = stream.params.streamID
          var uid1 = Cookies.get('type') + '-' + 'screen' + '-' + uid2
          var token1 = null
          // Initialize AgoraRTM client
          rt.clientRTM = await AgoraRTM.createInstance(AGORA_APP_ID)
          await rt.clientRTM.login({ uid: uid1, token: token1 })
          rt.currentUser = rt.clientRTM.context._uid
          // this.currentUser = uid1
          rt.channel1 = await rt.clientRTM.createChannel(rt.channel)
          await rt.channel1.join()
          await rt.channel1.sendMessage({ text: uid1, type: 'text' })
        }
      })

      rt.client.on('stream-removed', async function (evt) {
        const stream = evt.stream
        console.log('Stream removed: ' + stream.getId())
        console.log(new Date().toLocaleTimeString())
        console.log(evt)
        rt.removeStream(stream.getId())
        if (rt.screenshare === 1) {
          await rt.channel1.leave()
        }
        for (var k = 0; k < rt.channelMessageList.length; k++) {
          var string = rt.channelMessageList[k]
          var substring = stream.getId()
          if (string.includes(substring)) {
            rt.channelMessageList.splice(k, 1)
            rt.currentUser = rt.channelMessageList[0]
            if (string.includes('screen')) {
              rt.screenshare = 0
            }
            rt.clientRTM = await AgoraRTM.createInstance(AGORA_APP_ID)
            await rt.clientRTM.login({ uid: rt.currentUser, token: null })
            rt.channel1 = await rt.clientRTM.createChannel(rt.channel)
            await rt.channel1.join()
          }
        }
        await rt.sleep(1000)
      })
    },

    removeStream (uid) {
      this.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close()
          const element = document.querySelector('#ag-item-' + uid)
          if (element) {
            element.parentNode.removeChild(element)
          }
          const tempList = [...this.streamList]
          tempList.splice(index, 1)
          this.streamList = tempList
        }
      })
    },

    addStream (stream, push = false) {
      const repeatition = this.streamList.some(item => {
        return item.getId() === stream.getId()
      })
      if (repeatition) {
        return
      }
      if (push) {
        this.streamList = this.streamList.concat([stream])
      } else {
        this.streamList = [stream].concat(this.streamList)
      }
    },
    addChannel (channel, push = false) {
      // const repeatition = this.streamList.some(item => {
      //   return item.getId() === stream.getId()
      // })
      // if (repeatition) {
      //   return
      // }
      if (push) {
        this.channelList = this.channelList.concat([channel])
      } else {
        this.channelList = [channel].concat(this.channelList)
      }
    },
    handleCamera (e) {
      e.currentTarget.classList.toggle('off')
      this.localStream.isVideoOn()
        ? this.localStream.disableVideo()
        : this.localStream.enableVideo()
    },

    handleMic (e) {
      e.currentTarget.classList.toggle('off')
      this.localStream.isAudioOn()
        ? this.localStream.disableAudio()
        : this.localStream.enableAudio()
    },

    switchDisplay (e) {
      if (
        e.currentTarget.classList.contains('disabled') ||
        this.streamList.length <= 1
      ) {
        return
      }
      if (this.displayMode === 'pip') {
        this.displayMode = 'tile'
      } else if (this.displayMode === 'tile') {
        this.displayMode = 'pip'
      } else if (this.displayMode === 'share') {
        // do nothing or alert, tbd
      } else {
        console.error('Display Mode can only be tile/pip/share')
      }
    },

    hideRemote (e) {
      if (
        e.currentTarget.classList.contains('disabled') ||
        this.streamList.length <= 1
      ) {
        return
      }
      var list = []
      const id = this.streamList[this.streamList.length - 1].getId()
      list = Array.from(
        document.querySelectorAll(`.ag-item:not(#ag-item-${id})`)
      )
      list.map(item => {
        if (item.style.display !== 'none') {
          item.style.display = 'none'
        } else {
          item.style.display = 'block'
        }
      })
    },
    exitconfirmation (e) {
      console.log(e)
      this.chooseval = e
      console.log(this.chooseval)
      this.showexitform = true
    },
    closeendinterview () {
      this.showexitform = false
    },
    handleExit (e) {
      const type = this.type3
      // const type = localStorage.getItem('stType')
      // if (e.currentTarget.classList.contains('disabled')) {
      //   return
      // }
      try {
        this.client && this.client.unpublish(this.localStream)
        this.localStream && this.localStream.close()
        this.client && this.client.leave()
      } finally {
        this.readyState = false
        this.client = null
        this.localStream = null
        // redirect to index
      }
      console.log('stType type', type)
      if (type === '2' || type === 2) {
        console.log('end')
        this.endRecording()
      } else if (type === '1' || type === 1) {
        console.log('end1')
        this.changeleave(type)
        // router.push({ name: 'Result' })
        router.push({ name: 'DashboardNew' })
      } else {
        this.changeleave(type)
        window.location.href = 'https://screenit.io'
      }
    },
    getResource () {
      // this.changestatus()
      const formData = {
        cname: this.channel,
        uid: this.sid,
        clientRequest: {
          resourceExpiredHour: 24
        }
      }
      // const config = {
      //   headers: {
      //     'content-type': 'application/json',
      //     Authorization: `Basic ${token}`
      //   }
      // }
      // alert(this.checkStartRecording)
      if (this.checkStartRecording) {
        return false
      }
      if (!this.checkStartRecording) {
        console.log('welcome get resource')
        axios.post(BaseURL + '/dashboard/generate_resourceid', formData, this.config).then((response) => {
          const data = response.data
          this.resourceId = data.data.resourceId
          this.startRecording()
        })
      }
    },
    changestatus () {
      axios.get(BaseURL + '/dashboard/change_interview_status/' + this.sid, this.config).then(response => {
        console.log('changed status')
      }).catch(e => {
      })
    },
    startRecording () {
      const formData = {
        cname: this.channel,
        uid: this.sid
      }
      console.log(this.agora_sid)
      console.log('welcome start recording')
      if (this.checkStartRecording) {
        return false
      }
      axios.post(BaseURL + '/dashboard/start_recording/' + this.resourceId + '/mix', formData, this.config).then((response) => {
        const data = response.data.data
        this.checkStartRecording = true
        this.agora_sid = data.sid
      })
    },
    endRecording () {
      console.log('click end record')
      const formData = {
        cname: this.channel,
        uid: this.sid,
        interview_duration: this.durationval,
        clientRequest: {}
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Basic ${token}`
        }
      }
      console.log(this.appId)
      axios.post(BaseURL + '/dashboard/stop_recording/' + this.resourceId + '/' + this.agora_sid + '/mix', formData, config).then((response) => {
        console.log(response.data)
        window.location.href = 'https://screenit.io'
      }).catch(e => {
        console.log(e)
        // this.leaveCall()
        window.location.href = 'https://screenit.io'
      })
    },
    savefile (data) {
      console.log('click save file')
      const formData = {
        video_link: data,
        interview_duration: this.durationval
      }
      // if (this.userstype === 'self') {
      //   axios.post(BaseURL + '/dashboard/end_interview/self/' + this.sid, { formData: formData }, this.config).then((response) => {
      //     const data = response
      //     console.log(data)
      //     const type = Cookies.get('type')
      //     if (type === '1') {
      //       this.$router.push('/result')
      //     } else {
      //       window.location.href = 'https://screenit.io'
      //     }
      //   })
      // } else {
      axios.post(BaseURL + '/dashboard/end_interview/' + this.sid, { formData: formData }, this.config).then((response) => {
        const data = response
        console.log(data)
        window.location.href = 'https://screenit.io'
      })
      // }
    },
    getagoratoken () {
      const formData = {
        meeting_id: this.channel
      }
      axios.post(BaseURL + '/dashboard/get_token', { formData: formData }, this.config).then((response) => {
        const data = response.data
        console.log(data.temptoken)
        this.temptoken = data.temptoken
      })
    },
    getscheduleDetails (id) {
      const mainurl = '/dashboard/get_schedule_detail/' + id
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        this.userstype = response.data.refer_tag
        if (response.data.refer_tag !== 'self') {
          this.data = response.data.scheduleList[0]
        } else {
          this.data = response.data.scheduleList_self[0]
        }
        if (this.data.sid) {
          this.resourceId = this.data.resource_id
          this.agora_sid = this.data.sid
          this.checkStartRecording = true
        }
        // this.resourceId = data.resource_id
        // this.agora_sid = data.sid
        this.start_datetime = this.data.startdatetime_utc
        // var datetime = moment.utc(this.data.start_datetime).format('YYYYMMDDHHmm')
        // datetime = datetime - 5
        // var datetime = moment.utc(this.data.startdatetime_utc).subtract(5, 'minutes').toDate()
        // datetime = momentsone(datetime).tz(this.timezone).format('YYYYMMDDHHmm')
        // var enddatetime = moment.utc(this.data.enddatetime_utc)
        // var endtime = momentsone(enddatetime).tz(this.timezone).format('YYYYMMDDHHmm')
        console.log(this.current_date)
        // const types = localStorage.getItem('type')
        // if (this.data.status === 'Completed' || types == null) {
        //   if (types !== 1) {
        //     window.location.href = 'https://screenit.io'
        //     return false
        //   } else {
        //     router.push({ name: 'Login' })
        //   }
        // }
        this.job_title = this.data.job_tittle
        this.organization = this.data.organization
        // if (this.current_date < datetime && this.data.status === 'Open') {
        //   this.startPending()
        // } else if (this.current_date > endtime) {
        //   this.meetingEnd()
        // } else if (this.current_date < datetime && this.data.status !== 'Open') {
        //   this.meetingEnd()
        // }
        console.log(this.type)
        this.connectvideo()
      }).catch(e => {
        console.log(e)
      })
    },
    viewCodeEditor () {
      if (this.type === 2 || this.type === '2') {
        const route = router.resolve({ name: 'viewCode', params: { id: this.sid } })
        window.open(route.href, '_blank')
      } else {
        const route = router.resolve({ name: 'codeeditor', params: { id: this.sid } })
        window.open(route.href, '_blank')
      }
    },
    startPending () {
      router.push({ name: 'MeetingStart', params: { id: this.sid, type: this.type } })
    },
    meetingEnd () {
      router.push({ name: 'MeetingEnd', params: { id: this.sid, type: this.type } })
    },
    async connectvideo () {
      console.log(this.type)
      console.log(this.type1)
      if (this.type === 'null' || this.type === null || this.type === undefined) {
        const type = localStorage.getItem('type')
        console.log(type)
        if (type === 1) {
          this.$router.push('Dashboard')
          return false
        } else {
          window.location.href = 'https://screenit.io'
          return false
        }
      }
      const $ = this
      const config = {
        mode: 'live',
        codec: 'vp8'
      }
      var types = ''
      if (this.type === 1 || this.type === '1') {
        types = 'org'
      } else if (this.type === 2 || this.type === '2') {
        types = 'int'
      } else {
        types = 'candidate'
      }
      console.log('$.types -- ', types)
      this.streamCount = this.streamList.length
      // init AgoraRTC local client
      $.client = AgoraRTC.createClient(config)
      $.client.init($.appId, () => {
        console.log('AgoraRTC client initialized')
        $.subscribeStreamEvents()
        console.log($.appId)
        console.log($.channel)
        $.client.join($.appId, $.channel, $.uid, async uid => {
          this.uid = uid
          console.log('User ' + uid + ' join channel successfully')
          setInterval(function () {
            this.gettimer(1000)
          }.bind(this), 1000)
          console.log('At ' + new Date().toLocaleTimeString())
          // create local stream
          // It is not recommended to setState in function addStream
          $.localStream = await this.streamInit(uid, $.attendeeMode, $.videoProfile)
          $.localStream.init(
            () => {
              if ($.attendeeMode !== 'audience') {
                $.addStream($.localStream, true)
                $.client.publish($.localStream, err => {
                  console.log('Publish local stream error: ' + err)
                })
              }
              $.readyState = true
            },
            err => {
              console.log('getUserMedia failed', err)
              $.readyState = true
            }
          )
        })
      })
      if (this.type === '2') {
        if (!this.checkStartRecording) {
          console.log('welcome resource id')
          this.getResource()
        }
      }
    },
    select (id) {
      console.log(id)
    },
    async sharescreen (e) {
      console.log(e)
      var appID = this.appId
      var channel = this.channel
      var channelKey = this.appId
      this.screenshare = 1
      AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.INFO)
      const screenClient = AgoraRTC.createClient({
        mode: 'rtc',
        codec: 'vp8'
      })
      screenClient.init(appID, async function () {
        await screenClient.join(channelKey, channel, null, async function (uid) {
          // Create the stream for screen sharing.
          const streamSpec = {
            streamID: uid,
            audio: false,
            video: false,
            screen: true,
            types: 'screen',
            inttype: Cookies.get('type')
          }
          const screenStream = await AgoraRTC.createStream(streamSpec)
          // Initialize the stream.
          await screenStream.init(function () {
            AgoraRTC.getScreenSources(function (sources) {
              console.log('sources   ', sources)
            })
            console.log('screenStream   ', screenStream)
            // Play the stream.
            // Publish the stream.
            screenClient.publish(screenStream)
            screenStream.setScreenProfile('1080p_1')
          }, function (err) {
            console.log(err)
          })
        }, function (err) {
          console.log(err)
        })
      })
    },
    sleep (ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },
    changeleave (id) {
      console.log(id)
      if (id === 'yes') {
        id = localStorage.getItem('stType')
      }
      const formData = {
        _id: this.sid,
        type: id
      }
      axios.post(BaseURL + '/dashboard/leave_meeting', { formData: formData }, this.config).then((response) => {
        const data = response.data
        console.log(data)
      })
    },
    changetab () {
      console.log('super')
    },
    stop () {
      this.endRecording()
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    openNav () {
      document.getElementById('myModal2').style.width = '300px'
      this.scroll()
    },
    closeNav () {
      document.getElementById('myModal2').style.width = '0px'
      this.badgeShow = false
    },
    away () {
      console.log('away  ')
    },
    sendChatMessage (msg) {
      if (msg !== '') {
        console.log('message sendMessage chatMsg', this.chatMsg)
        this.chatMsg = ''
        this.channel1.sendMessage({ text: msg, type: 'text' })
        this.chatMessages.push({ text: msg, peerId: '', self: true, name: 'Me' })
        // this.badgeShow = true
        this.scroll()
      }
    },
    scroll () {
      document.getElementById('messages-content').scrollIntoView({ behavior: 'smooth' }, true)
      // var container = document.getElementById('messages-content')
      // container.scrollTop = container.scrollHeight
    }
  },
  created () {
    var currentDate = new Date()
    this.current_date = moment.utc(String(currentDate)).format('YYYYMMDDHHmm')
    this.getscheduleDetails(this.sid)
    // this.getagoratoken()
    // window.addEventListener('beforeunload', function (e) {
    //   $('#callstop').click()
    //   console.log(e)
    //   e.preventDefault() // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    //   //   // Chrome requires returnValue to be set
    //   e.returnValue = ''
    // })
    // window.addEventListener('beforeunload', function (e) {
    //   e.preventDefault()
    //   e.returnValue = ''
    //   $('#tabclose').click()
    // })
    const type = Cookies.get('type')
    if (type === 3 || type === '3') {
      $(window).blur(function () {
        $('#myModal1').modal('show')
      })
      $('#myModal1').modal('hide')
    }
  },
  mounted () {
    this.$nextTick(() => {
      // add listener to control btn group
      const canvas = document.querySelector('#ag-canvas')
      const btnGroup = document.querySelector('.ag-btn-group')
      canvas.addEventListener('mousemove', () => {
        if (global._toolbarToggle) {
          clearTimeout(global._toolbarToggle)
        }
        btnGroup.classList.add('active')
        global._toolbarToggle = setTimeout(function () {
          btnGroup.classList.remove('active')
        }, 2000)
      })
    })
  },

  async beforeUpdate () {
    // rerendering
    const canvas = document.querySelector('#ag-canvas')
    // pip mode (can only use when less than 4 people in channel)
    const screen = []
    const screen1 = []
    const org = []
    const candidate = []
    const interviewer = []
    if (this.streamList.length > 4) {
      this.displayMode = 'tile'
    } else {
      this.displayMode = 'pip'
    }
    if (this.displayMode === 'pip') {
      const no = this.streamList.length
      console.log(no)
      if (no > 4) {
        this.displayMode = 'tile'
        return
      }
      console.log('this.streamList ', this.streamList)
      if (this.currentUser !== '') {
        // if (!this.channelMessageList.length !== this.streamList.length) {
        this.channel1.sendMessage({ text: this.currentUser, type: 'text' })
        // }
      }
      var inArr = 0
      var name = ''
      this.channel1.on('ChannelMessage', (message, peerId) => {
        this.channelMessage = message
        if (this.channelMessageList.length !== 0) {
          for (var i = 0; i < this.channelMessageList.length; i++) {
            if (this.channelMessageList[i] === this.channelMessage.text) {
              inArr = 1
              break
            } else {
              inArr = 0
            }
          }
          if (inArr === 0) {
            this.channelMessageList.push(this.channelMessage.text)
            if (!this.channelMessage.text.includes('2-candidate') && !this.channelMessage.text.includes('3-candidate') && !this.channelMessage.text.includes('1-org') && !this.channelMessage.text.includes('1-screen') && !this.channelMessage.text.includes('2-screen') && !this.channelMessage.text.includes('3-screen')) {
              if (peerId.includes('2-candidate')) {
                name = this.data.interviewer_firstname + ' ' + this.data.interviewer_lastname
              } else if (peerId.includes('3-candidate')) {
                name = this.data.candidate_name + ' ' + this.data.candidate_lastname
              } else if (peerId.includes('1-org')) {
                name = this.data.org_firstname + ' ' + this.data.org_lastname
              } else if (peerId.includes('screen')) {
                name = this.data.candidate_name + ' ' + this.data.candidate_lastname
              }
              if (peerId !== this.currentUser) {
                this.chatMessages.push({ text: message.text, peerId: peerId, self: false, name: name })
                this.badgeShow = true
                this.scroll()
              }
            }
          }
        } else {
          this.channelMessageList.push(this.channelMessage.text)
          if (!this.channelMessage.text.includes('2-candidate') && !this.channelMessage.text.includes('3-candidate') && !this.channelMessage.text.includes('1-org') && !this.channelMessage.text.includes('1-screen') && !this.channelMessage.text.includes('2-screen') && !this.channelMessage.text.includes('3-screen')) {
            if (peerId.includes('2-candidate')) {
              name = this.data.interviewer_firstname + ' ' + this.data.interviewer_lastname
            } else if (peerId.includes('3-candidate')) {
              name = this.data.candidate_name + ' ' + this.data.candidate_lastname
            } else if (peerId.includes('1-org')) {
              name = this.data.org_firstname + ' ' + this.data.org_lastname
            } else if (peerId.includes('screen')) {
              name = this.data.candidate_name + ' ' + this.data.candidate_lastname
            }
            if (peerId !== this.currentUser) {
              this.chatMessages.push({ text: message.text, peerId: peerId, self: false, name: name })
              this.badgeShow = true
              this.scroll()
            }
          }
        }
      })
      var splitMsg = []
      if (this.channelMessage != null) {
        splitMsg = this.channelMessage.text.split('-')
      }
      var inArr1 = 0
      for (var i = 0; i < this.channelMessageList.length; i++) {
        if (this.channelMessageList[i] === this.currentUser) {
          inArr1 = 1
          break
        } else {
          inArr1 = 0
        }
      }
      if (inArr1 === 0 && this.currentUser !== '') {
        this.channelMessageList.push(this.currentUser)
      }
      var screenCon = 0
      for (var k = 0; k < this.channelMessageList.length; k++) {
        var string = this.channelMessageList[k]
        var substring = 'screen'
        if (string.includes(substring)) {
          screenCon = 1
          break
        } else {
          screenCon = 0
        }
      }
      var strIds = []
      this.streamList.map((item) => {
        strIds.push(String(item.params.streamID))
        if (item.params.inttype === Cookies.get('type')) {
          if (item.params.types === 'screen') {
            screen1.push('screen')
          }
        }
        if (item.params.types === 'screen') {
          screen.push('screen')
        }
        // end screen
        if (item.params.usertype === 'int') {
          interviewer.push('screen')
        }
        if (item.params.usertype === 'org') {
          org.push('screen')
        }
        if (item.params.usertype === 'candidate') {
          candidate.push('screen')
        }
      })
      if (screen1.length < 1) {
        // this.screenshare = 0
      }
      if (this.clientRTM !== null && this.clientRTM !== undefined && this.streamList.length !== this.channelMessageList.length) {
        this.channel1.getMembers().then((memberNames) => {
          // memberNames contains an array of the names of the members
          memberNames.forEach((el) => {
            var splitMem = el.split('-')
            if (strIds.includes(splitMem[2])) {
              if (!this.channelMessageList.includes(el)) {
                this.channelMessageList.push(el)
              }
            }
          })
        })
      }
      // leave video start
      // if (candidate.length < 1) {
      //   this.changeleave(3)
      // }
      // if (org.length < 1) {
      //   this.changeleave(1)
      // }
      // if (interviewer.length < 1) {
      //   this.changeleave(2)
      // }
      // this.streamListcount = this.streamList.length
      // leave video end
      this.streamList.map((item, index) => {
        const id = item.getId()
        console.log(this.screenshare + 'ss')
        let dom = document.querySelector('#ag-item-' + id)
        if (!dom) {
          if (this.screenshare !== 1) {
            dom = document.createElement('section')
            dom.setAttribute('id', 'ag-item-' + id)
            dom.setAttribute('class', 'ag-item')
            canvas.appendChild(dom)
            item.play('ag-item-' + id)
          }
          // document.getElementById('#ag-item-' + id).addEventListener('event', this.select2)
        }
        if (this.screenshare === 0) {
          if (screen.length > 0) {
            if (item.params.types !== 'screen') {
              console.log('check2a')
              dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
            } else {
              console.log('check3a')
              dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
            }
          } else {
            if (this.streamList.length === 1) {
              console.log('check2b1')
              dom.setAttribute('style', 'grid-area: span 12/span 24/13/25')
            } else if (this.streamList.length === 2) {
              dom.setAttribute('style', `grid-area: span 12/span 12/13/${(index + 1) * 30 / 2}`)
            } else {
              if (this.channelMessageList.length !== 0) {
                for (var i = 0; i < this.channelMessageList.length; i++) {
                  splitMsg = this.channelMessageList[i].split('-')
                  if (screenCon === 1) {
                    if (splitMsg[1] === 'screen' && this.screenshare !== 1 && splitMsg[2] === String(item.params.streamID)) {
                      dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                      break
                    } else {
                      if (this.screenshare !== 1) {
                        dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                      }
                      // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                    }
                  }
                  if (screenCon === 0) {
                    if (splitMsg[0] === '3' && splitMsg[1] === 'candidate' && splitMsg[2] === String(item.params.streamID)) {
                      dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                      break
                    } else {
                      dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                    }
                  }
                }
              }
            }
            // if (index === no - 1) {
            //   console.log('check2b')
            //   if (this.streamList.length === 1) {
            //     console.log('check2b1')
            //     dom.setAttribute('style', 'grid-area: span 12/span 24/13/25')
            //   } else {
            //     console.log('check2b2')
            //     if (item.params.usertype === 'org') {
            //       dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
            //     } else {
            //       dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
            //       // dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
            //     }
            //   }
            // } else {
            //   console.log('check3b ', item.params.usertype)
            //   // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
            //   if (item.params.usertype === 'candidate') {
            //     // candidate.push('screen')
            //     dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
            //   } else {
            //     dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
            //   }
            // }
          }
        } else if (this.screenshare === 1) {
          if (this.streamList.length === 1) {
            dom.setAttribute('style', 'grid-area: span 12/span 24/13/25')
          } else if (this.streamList.length === 2) {
            dom.setAttribute('style', `grid-area: span 12/span 12/13/${(index + 1) * 30 / 2}`)
          } else {
            if (this.channelMessageList.length !== 0) {
              for (var j = 0; j < this.channelMessageList.length; j++) {
                var splitMsg1 = this.channelMessageList[j].split('-')
                if (screenCon === 1) {
                  if (splitMsg1[1] === 'screen' && this.screenshare !== 1 && splitMsg1[2] === String(item.params.streamID)) {
                    dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                    break
                  } else {
                    if (this.screenshare !== 1) {
                      dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                    }
                    // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                  }
                }
                if (screenCon === 0) {
                  if (splitMsg1[0] === '3' && splitMsg1[1] === 'candidate' && splitMsg1[2] === String(item.params.streamID)) {
                    dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                    break
                  } else {
                    dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                  }
                }
              }
            }
          }
        }
        item.player.resize && item.player.resize()
      })
    } else if (this.displayMode === 'tile') {
      // tile mode
      console.log('this.streamList tile', this.streamList)
      if (this.currentUser !== '') {
        // if (!this.channelMessageList.length !== this.streamList.length) {
        this.channel1.sendMessage({ text: this.currentUser, type: 'text' })
        // }
      }
      var inArrr = 0
      var name1 = ''
      this.channel1.on('ChannelMessage', (message, peerId) => {
        this.channelMessage = message
        if (this.channelMessageList.length !== 0) {
          for (var i = 0; i < this.channelMessageList.length; i++) {
            if (this.channelMessageList[i] === this.channelMessage.text) {
              inArrr = 1
              break
            } else {
              inArrr = 0
            }
          }
          if (inArrr === 0) {
            this.channelMessageList.push(this.channelMessage.text)
            if (!this.channelMessage.text.includes('2-candidate') && !this.channelMessage.text.includes('3-candidate') && !this.channelMessage.text.includes('1-org') && !this.channelMessage.text.includes('1-screen') && !this.channelMessage.text.includes('2-screen') && !this.channelMessage.text.includes('3-screen')) {
              if (peerId.includes('2-candidate')) {
                name1 = this.data.interviewer_firstname + ' ' + this.data.interviewer_lastname
              } else if (peerId.includes('3-candidate')) {
                name1 = this.data.candidate_name + ' ' + this.data.candidate_lastname
              } else if (peerId.includes('1-org')) {
                name1 = this.data.org_firstname + ' ' + this.data.org_lastname
              } else if (peerId.includes('screen')) {
                name1 = this.data.candidate_name + ' ' + this.data.candidate_lastname
              }
              if (peerId !== this.currentUser) {
                this.chatMessages.push({ text: message.text, peerId: peerId, self: false, name: name1 })
                this.badgeShow = true
                this.scroll()
              }
            }
          }
        } else {
          this.channelMessageList.push(this.channelMessage.text)
          if (!this.channelMessage.text.includes('2-candidate') && !this.channelMessage.text.includes('3-candidate') && !this.channelMessage.text.includes('1-org') && !this.channelMessage.text.includes('1-screen') && !this.channelMessage.text.includes('2-screen') && !this.channelMessage.text.includes('3-screen')) {
            if (peerId.includes('2-candidate')) {
              name1 = this.data.interviewer_firstname + ' ' + this.data.interviewer_lastname
            } else if (peerId.includes('3-candidate')) {
              name1 = this.data.candidate_name + ' ' + this.data.candidate_lastname
            } else if (peerId.includes('1-org')) {
              name1 = this.data.org_firstname + ' ' + this.data.org_lastname
            } else if (peerId.includes('screen')) {
              name1 = this.data.candidate_name + ' ' + this.data.candidate_lastname
            }
            if (peerId !== this.currentUser) {
              this.chatMessages.push({ text: message.text, peerId: peerId, self: false, name: name1 })
              this.scroll()
            }
          }
        }
      })
      var splitMsgg = []
      if (this.channelMessage != null) {
        splitMsgg = this.channelMessage.text.split('-')
      }
      var inArrr1 = 0
      for (i = 0; i < this.channelMessageList.length; i++) {
        if (this.channelMessageList[i] === this.currentUser) {
          inArrr1 = 1
          break
        } else {
          inArrr1 = 0
        }
      }
      if (inArrr1 === 0 && this.currentUser !== '') {
        this.channelMessageList.push(this.currentUser)
      }
      var screenCon1 = 0
      for (k = 0; k < this.channelMessageList.length; k++) {
        var string1 = this.channelMessageList[k]
        var substring1 = 'screen'
        if (string1.includes(substring1)) {
          screenCon1 = 1
          break
        } else {
          screenCon1 = 0
        }
      }
      const no = this.streamList.length
      var strCount = 0
      await this.streamList.map((item, index) => {
        const id = item.getId()
        let dom = document.querySelector('#ag-item-' + id)
        if (!dom) {
          dom = document.createElement('section')
          dom.setAttribute('id', 'ag-item-' + id)
          dom.setAttribute('class', 'ag-item')
          canvas.appendChild(dom)
          item.play('ag-item-' + id)
        }
        if (this.channelMessageList.length !== 0) {
          var isScreen = false
          for (var x = 0; x < this.channelMessageList.length; x++) {
            // splitMsgg = this.channelMessageList[i].split('-')
            var ms = this.channelMessageList[x]
            if (this.channelMessageList[x].includes('screen')) {
              this.channelMessageList.splice(x, 1)
              this.channelMessageList.splice(0, 0, ms)
              isScreen = true
              break
            }
          }
          if (isScreen === false) {
            for (x = 0; x < this.channelMessageList.length; x++) {
              // splitMsgg = this.channelMessageList[i].split('-')
              ms = this.channelMessageList[x]
              if (this.channelMessageList[x].includes('3-candidate')) {
                this.channelMessageList.splice(x, 1)
                this.channelMessageList.splice(0, 0, ms)
                break
              }
            }
          }
        }
        // dom.setAttribute('style', `grid-area: ${tileCanvas[no][index]}`)
        if (this.screenshare === 0) {
          if (screen.length > 0) {
            if (item.params.types !== 'screen') {
              console.log('check2a')
              // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
            } else {
              console.log('check3a')
              // dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
            }
          } else {
            if (this.channelMessageList.length !== 0) {
              for (var i = 0; i < this.channelMessageList.length; i++) {
                splitMsgg = this.channelMessageList[i].split('-')
                if (screenCon1 === 1) {
                  if (splitMsgg[1] === 'screen' && this.screenshare !== 1 && splitMsgg[2] === String(item.params.streamID)) {
                    // dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                    dom.setAttribute('style', `grid-area: ${tileCanvas[no][no - 1]}`)
                    break
                  } else {
                    if (strCount < no - 1) {
                      strCount++
                      if (this.screenshare !== 1) {
                        dom.setAttribute('style', `grid-area: ${tileCanvas[no][strCount - 1]}`)
                      }
                      // dom.setAttribute('style', `grid-area: ${tileCanvas[no][strCount - 1]}`)
                      // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                      break
                    }
                  }
                }
                if (screenCon1 === 0) {
                  if (splitMsgg[0] === '3' && splitMsgg[1] === 'candidate' && splitMsgg[2] === String(item.params.streamID)) {
                    // dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                    dom.setAttribute('style', `grid-area: ${tileCanvas[no][no - 1]}`)
                    break
                  } else {
                    if (strCount < no - 1) {
                      strCount++
                      dom.setAttribute('style', `grid-area: ${tileCanvas[no][strCount - 1]}`)
                      // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                      break
                    }
                  }
                }
              }
            }
          }
        } else if (this.screenshare === 1) {
          if (this.channelMessageList.length !== 0) {
            for (var j = 0; j < this.channelMessageList.length; j++) {
              var splitMsgg1 = this.channelMessageList[j].split('-')
              if (screenCon1 === 1) {
                if (splitMsgg1[1] === 'screen' && this.screenshare !== 1 && splitMsgg1[2] === String(item.params.streamID)) {
                  // dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                  dom.setAttribute('style', `grid-area: ${tileCanvas[no][no - 1]}`)
                  break
                } else {
                  if (strCount < no - 1) {
                    strCount++
                    if (this.screenshare !== 1) {
                      dom.setAttribute('style', `grid-area: ${tileCanvas[no][strCount - 1]}`)
                    }
                    // dom.setAttribute('style', `grid-area: ${tileCanvas[no][strCount - 1]}`)
                    // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                    break
                  }
                }
              }
              if (screenCon1 === 0) {
                if (splitMsgg1[0] === '3' && splitMsgg1[1] === 'candidate' && splitMsgg1[2] === String(item.params.streamID)) {
                  // dom.setAttribute('style', 'grid-area: span 12/span 24/13/21')
                  dom.setAttribute('style', `grid-area: ${tileCanvas[no][no - 1]}`)
                  break
                } else {
                  if (strCount < no - 1) {
                    strCount++
                    dom.setAttribute('style', `grid-area: ${tileCanvas[no][strCount - 1]}`)
                    // dom.setAttribute('style', `grid-area: span 3/span 4/${4 + 3 * index}/25`)
                    break
                  }
                }
              }
            }
          }
        }
        item.player.resize && item.player.resize()
      })
    } else if (this.displayMode === 'share') {
      // screen share mode (tbd)
    }
  },

  beforeDestroy () {
    this.client && this.client.unpublish(this.localStream)
    // this.localStream && this.localStream.close()
    this.client &&
      this.client.leave(
        () => {
          console.log('Client succeed to leave.')
        },
        () => {
          console.log('Client failed to leave.')
        }
      )
  }
}
</script>

<style>

.meeting.wrapper {
  background:#393939;
  height: 100%;
}

.meeting .ag-header {
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #373644;
}

.ag-header-lead {
  font-size: 16px;
  line-height: 35px;
}

.meeting .ag-footer {
  padding: 0 30px;
  display: flex;
  align-items: center;
}

.meeting .ag-main {
  position: fixed;
  height: 100%;
  width: 100%;
}

.meeting .ag-footer :first-child {
  margin-right: 80px;
}

.header-logo {
  width: 121px;
  margin-right: 12px;
}

.ag-container {
  width: inherit;
  height: 100%;
  margin: 0 auto;
  /* background: rgba(255, 255, 255, 0.1); */
  border-radius: 12px;
}
.ag-header-msg {
  color: white;
}
.meeting-label {
  border: 1px solid #cfcbcb85;
  padding: 6px;
}
.end-interview {
  background-color: #D13232;
  padding: 6px;
  cursor: pointer;
}
.time-duration {
  margin-right: -79px;
  background-color: #FFFFFF;
  padding: 6px;
  color: #d13232;
}
#ag-canvas {
  height: 100%;
  min-height: 75vh;
  max-height: 80vh;
  /* min-height: 415px; */
  display: grid;
  grid-gap: 10px;
  align-items: center;
  justify-items: center;
  grid-template-rows: repeat(12, auto);
  grid-template-columns: repeat(24, auto);
  padding: 5px;
}

.ag-item :first-child {
  border-radius: 0px;
}
.ag-item {
  border-radius: unset;
  border: 0px #00b6ed solid;
  background: url(data:image/png;base64,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) center no-repeat;
  height: 100%;
  width: 100%;
}

#ag-resize-container {
  background-image: none !important;
  background-color: black;
  display: flex;
  justify-content: center;
  height: center;
}

#ag-resize-container .ag-item {
  border: none !important;
}

/* button group */
.ag-btn-group {
  height: 70px;
  /* width: calc(100% - 60px); */
  width: 100%;
  margin: 6px auto;
  /* position: absolute; */
  bottom: 0;
  /* background: transparent; */
  z-index: 11;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* background: rgba(18, 74, 99, 0.8); */
  background: #F8F8F80D 0% 0% no-repeat padding-box !important;
  background-color: #393939 !important;
}

.ag-btn-group:hover,
.ag-btn-group.active {
  /* background: rgba(18, 74, 99, 0.8); */
  background: #F8F8F80D 0% 0% no-repeat padding-box !important;
  background-color: #393939 !important;
}

.ag-btn {
  z-index: 12;
  /* opacity: 0; */
  color: white;
  /* width: 35px;
    height: 35px; */
  cursor: pointer;
  font-size: 60px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.ag-btn:hover {
  color: #00b6ed;
}

.ag-btn.disabled,
.ag-btn.disabled:hover {
  color: #637c8e;
  cursor: not-allowed;
}

.ag-btn-group:hover .ag-btn,
.ag-btn-group.active .ag-btn {
  opacity: 1;
}
.ag-btn.off.videoControlBtn .ag-icon-camera {
  display: none;
}
.ag-btn.videoControlBtn .ag-icon-camera-off {
  display: none;
}
.ag-btn.videoControlBtn .ag-icon-camera {
  display: inline-block;
}
.ag-btn.off.videoControlBtn .ag-icon-camera-off {
  display: inline-block;
}
.ag-btn.off.audioControlBtn .ag-icon-mic {
  display: none;
}
.ag-btn.audioControlBtn .ag-icon-mic-off {
  display: none;
}
.ag-btn.audioControlBtn .ag-icon-mic {
  display: inline-block;
}
.ag-btn.off.audioControlBtn .ag-icon-mic-off {
  display: inline-block;
}

video {
  max-width: unset !important;
}
/* .ag-container {
  width: 845px !important;
} */
.overlay {
  position: fixed; /* Positioning and size */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128,128,128,0.5); /* color */
  display: none; /* making it hidden by default */
}
.white-board {
  position: absolute;
  bottom: 12px;
  right: 30px;
  background: white;
  padding: 5px;
  border-radius: 20px;
  cursor: pointer;
}
.white-board i {
  background: #B971F9 0% 0% no-repeat padding-box;
  opacity: 1;
  color: white;
  padding: 6px;
  border-radius: 12px;
}
.white-board-text {
  position: absolute;
  bottom: 54px;
  right: 30px;
  background: white;
  padding: 5px;
}
.clear-board {
  cursor: pointer;
  color: red;
}
.footerfix {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: unset !important;
  margin: unset;
}
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  /* z-index: 1; */
  top: 0;
  right: 0;
  background-color: white;
  overflow-x: hidden;
  /* transition: 0.5s; */
  padding-top: 60px;
}

.sidenav .closebtn {
  position: fixed;
  top: 0;
  right: 5px;
  font-size: 28px;
  margin-left: 50px;
  overflow-x: hidden;
  color: black;
}
/* .chat-header {
  background-color: #00b6ed;
  position: sticky;
  position: -webkit-sticky;
} */
/* .sidenav .chat-message {
  height:auto;
} */
.sidenav .header {
  position: fixed;
  top: 0;
  font-size: 26px;
  margin-left: 10px;
  overflow-x: hidden;
}
.sidenav .footer-chat {
  position: absolute;
  bottom: 10px;
  /* width: 240px; */
  /* font-size: 20px; */

}
.sidenav .footer-chat-input {
  position: fixed;
  bottom: 10px;
  width: 240px;
  /* font-size: 20px; */
  margin-left: 10px;
}
.button-send {
  background-color: #5bad2b; /* Green */
  border: none;
  color: white;
  padding: 7px 10px 7px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 22px;
  margin: -44px 2px;
  cursor: pointer;
  border-radius: 70%;
  margin-left: 255px;
  position: fixed;
}
@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
}
.speech-wrapper{
  padding: 15px 6px;
}
.chatbox {
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 0px;
  background: #5bad2b;
  color: #FFF;
  position: relative;
  border-radius: 10px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  box-shadow: 0 8px 6px -6px black;
}
.chatbox_other{
  height:auto;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top:0px;
  background: #DCDCDC;
  color: #000;
  position: relative;
  border-radius: 10px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  box-shadow: 0 8px 6px -6px black;
}
.timestamp_other{
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  right: 10px;
  text-transform: uppercase; color: #999
}
.timestamp{
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  right: 10px;
  text-transform: uppercase; color: #fff
}
.chat-header-name{
  font-weight: 600;
  font-size: 12px;
  margin: 0px 0px  9px;
  color: #ffffff;
}
.triangle.left-top:after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: -10px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 22px solid;
  border-color: #DCDCDC transparent transparent transparent;
  z-index: -1;
}
.triangle.right-top:before {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -10px;
  top: 0;
  bottom: auto;
  border: 32px solid;
  border-color: #5bad2b transparent transparent transparent;
  z-index: -1;
}
.alt{
  margin: 0 0 0 90px;
}
.altleft{
  margin: 0 90px 0 0px;
}
.chatarea{
  height: 300px;
  width: auto;
  display: block;
}
.top-div{
  width: 300px;
  height: 80vh;
  max-height: 500px;
  z-index: 2;
  overflow: hidden;
  /* box-shadow: 0 5px 30px rgba(0, 0, 0, .2); */
  /* background: rgba(0, 0, 0, .5); */
  /* border-radius: 20px; */
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.chat-header {
  flex: 0 1 1px;
  position: relative;
  z-index: 2;
  /* background: rgba(254, 9, 9, 0.2); */
  color: rgb(3, 0, 0);
  text-align: left;
  padding: 0px 4px 1px 0px;
}
.chat-message{
  flex: 1 1 auto;
  /* color: rgba(255, 255, 255, .5); */
  overflow: hidden;
  position: relative;
  width: 100%;
}
.messages-content {
  position: absolute;
  top: 0;
  left: 0;
  height: 101%;
  width: 100%;
  overflow-y: scroll;
}
.badge {
    position: relative;
    top: -24px;
    left: 3px;
    border-radius: 50%;
    background-color: #5bad2b;
    color: #5bad2b;
    /* font-size: 4px; */
    padding: 0px;
}
</style>
